import React from 'react'
import { Container, Description, Title, WrapperText } from './styles'
import Icon from '../Icon'

export const AlertBox = ({
  title,
  description,
  iconName,
  type='warning'
}) => {
  return (
    <Container type={type}>
      <Icon name={iconName} type={type} />
      <WrapperText>
        <Title type={type}>
          {title}
        </Title>
        <Description type={type}>
          {description}
        </Description>
      </WrapperText>
    </Container>
  )
}
